import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { StaticUrls, Servizio, ServizioAcquistato } from '../models';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { tokenNotExpired, AuthHttp } from 'angular2-jwt';
import { MyCookieService } from './my-cookie.service';
import { environment } from 'environments/environment';

@Injectable()
export class PagamentoService {
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });
	private serviziImmobile: Array<ServizioAcquistato>;

	constructor(private http: AuthHttp,
		@Inject(MyCookieService) private myCookieService: MyCookieService,
		private router: Router) { }

	pagamentoContrattoPubblicazione(servizio: Servizio, idImmobile: number){
		return this.http.post(StaticUrls.pagamentoContrattoPubblicazione(idImmobile), {},this.options)
		.map(response => {
			if (response.status === 200) {
				return response;
			} else {
				return undefined;
			}
		})
		.catch(this.handleError);
	}

	pagamentoContrattoServizi(servizi: Array<ServizioAcquistato>){
		return this.http.post(StaticUrls.pagamentoContrattoServizi, JSON.stringify(servizi), this.options)
		.map(response => {
			if (response.status === 200) {
				return response;
			} else {
				return undefined;
			}
		})
		//.catch(this.handleError);
	}

	// PayPal
	creaPagamentoPayPal(servizi: Array<ServizioAcquistato>){
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls.creaPagamentoPP, JSON.stringify(servizi), this.options)
					.map(response => {
						if (response.status === 200) {
							return response.text();
						} else {
							return undefined;
						}
					})
					.catch(this.handleError);
			}
		}
	}

	creaSubscriptionPayPal(servizio: Servizio, idImmobile: number){
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				let servizioAcquistato = new ServizioAcquistato(idImmobile, servizio.tipologiaServizio.id, servizio.costoScontato, null);
				return this.http.post(StaticUrls.creaSubscriptionPP, JSON.stringify(servizioAcquistato), this.options)
					.map(response => {
						if (response.status === 200) {
							return response;
						} else {
							return undefined;
						}
					});
			}
		}
	}

	accettaSubscriptionPayPal(token: string){
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls.acettaSubscriptionPP(token), null, this.options)
					.map(response => {
						if (response.status === 200) {
							return response.text();
						} else {
							return undefined;
						}
					}).catch(this.handleError);
			}
		}
	}

	cancellaSubscriptionPayPal(token: string){
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls.cancellaSubscriptionPP(token), null, this.options)
					.map(response => {
						if (response.status === 200) {
							return response.text();
						} else {
							return undefined;
						}
					}).catch(this.handleError);
			}
		}
	}

	// Nexi
	postSemplice(servizi: Array<ServizioAcquistato>) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {
				return this.http.post(StaticUrls._pagamento_semplice, JSON.stringify(servizi), this.options)
					.map(response => {
						if (response.status === 200) {
							return response.text();
						} else {
							return response;
						}
					})
			}
		}
	}

	postRicorrente(servizio: Servizio, idImmobile: number) {
		if (this.myCookieService.token) {
			if (this.ifTokenExpired()) {

				let servizioAcquistato = new ServizioAcquistato(idImmobile, servizio.tipologiaServizio.id, servizio.costoScontato, null);

				return this.http.post(StaticUrls._pagamento_ricorrente, JSON.stringify(servizioAcquistato), this.options)
					.map(response => {
						if (response.status === 200) {
							return response.text();
						} else {
							return undefined;
						}
					})
					.catch(this.handleError);
			}
		}
	}

	servizioForEach(value: Servizio, index: number, array: Servizio[]) {
		this.serviziImmobile.push(new ServizioAcquistato(null, value.tipologiaServizio.id, value.costoScontato, null));
	}

	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
			if (error.status == 401) {
				this.router.navigate(['login']);
			}
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenExpired() {
		if (this.myCookieService.token) {
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/pagamento.service.ts